import clamp from 'lodash/clamp';
import { MAXIMUM_ZOOM_LEVEL, MINIMUM_ZOOM_LEVEL } from './ellipsis.tsx';
import { getLinearZoom, getExponentialZoom, clampZoom } from './getExponentialZoom.tsx';

/** Converts a deltaY (ctrl+scroll delta, or trackpad pinch gesture delta) */
export const getZoomFromDeltaY = (
	deltaY: number,
	currentZoom: number,
	minZoom: number = MINIMUM_ZOOM_LEVEL,
	maxZoom: number = MAXIMUM_ZOOM_LEVEL,
): number => {
	const delta = clamp(deltaY, -0.1, +0.1);
	const newLinearZoom = getLinearZoom(currentZoom) - delta;
	const newZoom = getExponentialZoom(newLinearZoom);
	return clampZoom(newZoom, minZoom, maxZoom);
};
